module.exports = __webpack_public_path__ + "img/ergo.967d0df9.png";